import { useState } from 'react';
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerFooter, DrawerDescription } from '@/components/ui/drawer';
import { Button } from '@/components/ui/button';
import { useSubmitItemIssue } from '@/hooks/useItemDataIssues';
import { AlertTriangle } from 'lucide-react';

interface FixItemInfoSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  savedItemId: string;
}

export function FixItemInfoSheet({ open, onOpenChange, savedItemId }: FixItemInfoSheetProps) {
  const submitIssue = useSubmitItemIssue();

  const handleSubmit = () => {
    submitIssue.mutate(
      { savedItemId, issues: ['needs_review'] },
      {
        onSuccess: () => {
          onOpenChange(false);
        },
      }
    );
  };

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent>
        <DrawerHeader className="text-center">
          <div className="mx-auto w-12 h-12 rounded-full bg-muted flex items-center justify-center mb-2">
            <AlertTriangle className="w-6 h-6 text-muted-foreground" />
          </div>
          <DrawerTitle>Something not right?</DrawerTitle>
          <DrawerDescription>
            We'll take a look and fix any incorrect info for this item.
          </DrawerDescription>
        </DrawerHeader>
        <DrawerFooter>
          <Button onClick={handleSubmit} disabled={submitIssue.isPending}>
            {submitIssue.isPending ? 'Sending…' : 'Send for review'}
          </Button>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}
